
// TIMEOUT THE VIDEO
var timeoutInMiliseconds = 1*60*1000;
var timeoutId; 
  
function startTimer() {timeoutId = window.setTimeout(doInactive, timeoutInMiliseconds)}
function resetTimer() {document.querySelectorAll('video[autoplay]').forEach(v=>{v.play()});window.clearTimeout(timeoutId);startTimer();}
function doInactive() {document.querySelectorAll('video[autoplay]').forEach(v=>{v.pause()});}
 
(function setupTimers () {
    document.addEventListener("scroll", resetTimer, false);
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("mousedown", resetTimer, false);
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);
     
    startTimer();
})()

// endless scroll
//  document.addEventListener("DOMContentLoaded", function() {
//      var endlessScroll = new Ajaxinate();
//  });

window.addEventListener("load", function() {
if(window.jQuery)(function ($){
  $("#admin-bar-iframe").hide();
  $(window).on("keydown",(e)=>{
  	if(e.key === "Escape") $("#admin-bar-iframe").toggle();
  })
})(window.jQuery)
})